<template>
  <div>
    <TitlePage :title="$t('closures')"></TitlePage>

    <v-form @submit.prevent="update()" class="bb-gray pb-5" ref="form_create" v-model="check">
      <v-layout wrap>

        <v-flex md12 class="pl-4 pr-4">
          <v-text-field :label="$t('name')" v-model="item.name" :rules="[rules.required]"></v-text-field>
        </v-flex>


        <v-flex md12 class="pt-10 d-flex">
          <v-divider class="marg-title"></v-divider>
        </v-flex>


        <v-flex md12 class="pl-4 pr-4 pt-4">
          <span class="font-weight-bold">Campi da chiudere</span>
        </v-flex>

        <template v-for="field in this.field_list">
          <v-flex md3 class="pl-4 pr-4">
            <v-checkbox
                v-model="item.fields"
                :label="field.name"
                :value="field._id"
            ></v-checkbox>
          </v-flex>
        </template>

        <v-flex md12 class="pb-10 d-flex">
          <v-divider class="marg-title"></v-divider>
        </v-flex>


        <v-col cols="12" md="4" class="pl-4 pr-4">
          <v-dialog ref="dialog_start" v-model="modal_start" :return-value.sync="item.date_start" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateStartFormatted" label="Data di Inizio"  readonly v-bind="attrs" v-on="on" dense></v-text-field>
            </template>
            <v-date-picker :first-day-of-week="1" v-model="item.date_start" scrollable @input="modal_start = false;$refs.dialog_start.save(item.date_start)">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal_start = false">
                {{ $t('back') }}
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog_start.save(item.date_start)">
                {{ $t('confirm') }}
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col cols="12" md="4"  class="pl-4 pr-4">
          <v-dialog ref="dialog_end" v-model="modal_end" :return-value.sync="item.date_end" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateEndFormatted" label="Data di Fine" readonly v-bind="attrs" v-on="on" dense></v-text-field>
            </template>
            <v-date-picker :first-day-of-week="1" v-model="item.date_end" scrollable @input="modal_end = false;$refs.dialog_end.save(item.date_end)">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal_end = false">
                {{ $t('back') }}
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog_end.save(item.date_end)">
                {{ $t('confirm') }}
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-flex md2 class="pl-4 pr-4">
          <v-switch v-model="item.all_day" inset label="Tutto il giorno"></v-switch>
        </v-flex>

        <template v-if="!item.all_day">
          <v-flex md4 xs12 class="pl-4 pr-4">
            <v-menu ref="menu_open" v-model="menu_ot" :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="item.time_start"
                    transition="scale-transition" offset-y max-width="290px" min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="item.time_start" :label="$t('openTime')"
                              prepend-icon="mdi-clock-time-four-outline" readonly
                              v-bind="attrs" v-on="on">
                </v-text-field>
              </template>
              <v-time-picker v-if="menu_ot" v-model="item.time_start" full-width
                             @click:minute="$refs.menu_open.save(item.time_start)"
                             format="24hr"></v-time-picker>
            </v-menu>
          </v-flex>

          <v-flex md4 xs12 class="pl-4 pr-4">
            <v-menu ref="menu_close" v-model="menu_ct" :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="item.time_end"
                    transition="scale-transition" offset-y max-width="290px" min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="item.time_end" :label="$t('closeTime')"
                              prepend-icon="mdi-clock-time-four-outline" readonly
                              v-bind="attrs" v-on="on">
                </v-text-field>
              </template>
              <v-time-picker v-if="menu_ct" v-model="item.time_end" full-width
                             @click:minute="$refs.menu_close.save(item.time_end)"
                             format="24hr"></v-time-picker>
            </v-menu>
          </v-flex>
        </template>

        <v-flex md12 class="pt-10 d-flex">
          <v-divider class="marg-title"></v-divider>
        </v-flex>

        <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
          <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
            <v-icon left>mdi-keyboard-backspace</v-icon>
            {{ $t('back') }}
          </v-btn>
          <v-btn elevation="2" color="primary" class="ml-auto" type="submit">
            {{ $t('save') }}
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-flex>

      </v-layout>

    </v-form>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  name: "EditClosure",
  components: {TitlePage},
  data() {
    return {
      field_list:[],
      menu_ot: false,
      menu_ct: false,
      item: {
        center_id: this.$route.params.centerId,
        fields: [],
        name: '',
        date_start: null,
        date_end: null,
        time_start: null,
        time_end: null,
        all_day: null
      },
      check: true,
      rules: {
        required: value => !!value || this.$t('fillMandatory'),
        number_gt_zero: v => v > 0 || this.$t('fillMandatory'),
      },
      modal_start: false,
      modal_end: false,
    };
  },
  async created(){
    this.setLoading(true);
    let fetchItem = await this.editItem(this.$route.params)

    let date_start = new Date(fetchItem.result.date_start)
    let date_end = new Date(fetchItem.result.date_end)

    this.item.fields = fetchItem.result.fields;
    this.item.name = fetchItem.result.name;
    this.item.date_start = date_start.toISOString().split('T')[0];
    this.item.date_end = date_end.toISOString().split('T')[0];
    this.item.all_day = fetchItem.result.all_day;

    this.item.time_start = (fetchItem.result.all_day) ? null : fetchItem.result.time_start
    this.item.time_end = (fetchItem.result.all_day) ? null : fetchItem.result.time_end

    let fields = await this.getCompleteList({center_id:this.$route.params.centerId});
    for(let field of fields.results){
      if(field.active){
        let sports = field.sports_info.map(item => item['name']).join(', ');
        this.field_list.push({name:field.name+' ('+sports+')', _id: field._id})
        this.field_list = this.field_list.sort((a, b) => {
          if (a['name'].toLowerCase() < b['name'].toLowerCase()) {
            return -1;
          }
          if (a['name'].toLowerCase() > b['name'].toLowerCase()) {
            return 1;
          }
          return 0;
        });
      }
    }

    this.setLoading(false);
  },
  computed: {
    dateStartFormatted () {
      return this.formatDateHuman(this.item.date_start)
    },
    dateEndFormatted () {
      return this.formatDateHuman(this.item.date_end)
    },
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem': 'closures/edit',
      'updateItem': 'closures/update',
      'getCompleteList': 'fields/getCompleteList',
    }),
    async update(){

      this.$refs.form_create.validate()
      if(!this.check){
        return
      }

      if(!this.item.date_start || !this.item.date_end){
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Errore: Selezionare una data di Inizio ed una data di Fine'
        })
        this.setLoading(false);
        return false
      }

      let start = new Date(this.item.date_start)
      let end = new Date(this.item.date_end)
      end.setHours(23,59,59,0);

      if(end < start){
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Errore: Data di Fine antecedente alla data di Inizio'
        })
        this.setLoading(false);
        return false
      }

      if(this.item.all_day){
        this.item.time_start = null
        this.item.time_end = null
      }

      if(this.item.time_start >= this.item.time_end && !this.item.all_day){
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Errore: Orario di Chiusura antecedente all\'orario di Apertura'
        })
        this.setLoading(false);
        return false
      }

      await this.setLoading(true);
      let result = await this.updateItem({...this.$route.params, item:this.item})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

    formatDateHuman(my_date) {
      if(my_date){
        let date = new Date(my_date)
        return ('0' + date.getDate()).slice(-2)+'-'+('0' + (date.getMonth()+1)).slice(-2)+'-'+date.getFullYear()
      }else {
        return ''
      }
    },

  },
  mounted() {

  },
}
</script>

<style scoped>

</style>